import React from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { AppState } from '../../../../store/store.types';
import { DATE_TIME_FORMAT } from '../../../../api/api.types';
import {
  ListAllUsersResponse,
  UserModel,
  UserResponse,
  UserRole
} from '../../../../api/authentication/authentication.types';
import { AuthenticationApi } from '../../../../api/api.apiclient';
import dayjs from 'dayjs';
import { WithTranslation, withTranslation } from 'react-i18next';
import ListViewTable from '../../../../components/tables/ListViewTable';

interface UsersProps extends RouteComponentProps, WithTranslation {
  user: UserModel | null;
}

interface UsersState {
  totalElements: number;
  users: UserResponse[];
  problemLoading: boolean;
}

class Users extends React.Component<UsersProps, UsersState> {

  readonly state = {
    totalElements: 0,
    users: [] as UserResponse[],
    problemLoading: false
  };

  componentDidMount() {
    AuthenticationApi.user.listUsers().then((data: ListAllUsersResponse) => {
      this.setState({
        totalElements: data.total,
        users: data.users,
        problemLoading: false
      });
    }).catch((e: any) => this.setState({ problemLoading: true }));
  }

  onRowClick = (rowInfo: any) => (
    this.props.history.push(`/admin/users/${rowInfo.original.username}/view`)
  );

  loginCell = ({ cell }: { cell: any }) => (<div>{dayjs(cell.row.original.lastLogin).format(DATE_TIME_FORMAT)}</div>);

  getUsersForTable = () => {
    if (this.props.user && this.props.user.roles.find((r) => r === UserRole.SUPPLIER_ADMIN)) {
      return this.state.users.filter((u) => u.userPermissionGroupName !== 'RateChain Admin' && u.userPermissionGroupName !== 'RateChain support' && u.userPermissionGroupName !== 'Broker');
    }

    return this.state.users;
  };

  defineColumns() {
    const { t } = this.props;

    return [
      {
        header: t('ct.users.username'), accessorKey: 'username', id: 'username'
      },
      {
        header: t('ct.users.email'), accessorKey: 'email', id: 'email'
      },
      {
        header: t('ct.users.permission_group'), accessorKey: 'userPermissionGroupName', id: 'userPermissionGroupName'
      },
      {
        header: t('ct.users.last_login'),
        accessorKey: 'lastLogin',
        cell: ({ cell }: { cell: any }) => this.loginCell({ cell }),
        id: 'lastLogin'
      }
    ];
  }

  render() {
    const { t } = this.props;

    return (
        <main>
          <div className="page-content">
            <div className="d-flex justify-content-between align-items-center mt-2 mb-1">
              <h1>{t('page_title.users')}</h1>
              <Link
                to={{
                  pathname: '/admin/users/create'
                }}
                className="btn btn-primary btn-wide"
              >
                {t('b.add_new').toUpperCase()}
              </Link>
            </div>
            {this.state.users && this.state.users.length && !this.state.problemLoading ? (
                <div className="table-list">
                  <ListViewTable data={this.state.users} columns={this.defineColumns()} getTrProps={this.onRowClick}/>
                </div>
            ) : ''}
            {!this.state.users.length && !this.state.problemLoading && (
              <div className="d-flex justify-content-center align-items-center temp-container">
                <Spinner animation="border" variant="info"/>
              </div>
            )}
            {this.state.problemLoading && (
              <div className="temp-container">
                <div>Failed to load users</div>
              </div>
            )}
            <div className="d-flex mt-2">
              <div>{`Result ${this.state.totalElements} Users`}</div>
            </div>
          </div>
        </main>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user
});

export default withTranslation()(connect(
  mapStateToProps
)(Users));
